<template>
  <base-section
    id="student-activities"
  >
    <v-container>
      <base-section-heading
      title="Student Activities at ETS'23"
      />
      <base-section-heading
      divider=null
      >
      ETS'23 is organizing several activities for students, who will have the opportunity to engage with each other and with experts in the field. Below are the possible submissions dedicated to students and the awards in which they can participate.
      </base-section-heading>
      <br>
      <v-row>
        <base-info-student
        v-for="(act, i) in activities"
        :key="i"
        :text="act.text"
        :title="act.title"
        :to="act.to"
        >
        </base-info-student>
      </v-row>
      <v-row>
        <base-avatar-card
          title="Student Activities Co-Chairs"
          align="left"
          horizontal
        />
      </v-row>
      <v-row>
        <v-col
          v-for="(studentact, i) in studentacts"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="studentact"
            align="left"
            horizontal
          />
        </v-col>
      </v-row>
      <br>
      <br>
        <v-footer
          id="program-footer"
          color="primary"
          dark
          min-height="72"
          class="hidden-md-and-up"
        >
          <v-container>
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <div class="d-flex flex-wrap justify-md-start justify-center justify-md-none">
                  <template v-for="(s, i) in studentsfooter">
                    <router-link
                      :key="s.name"
                      class="white--text pa-1 pa-md-0"
                      :to="s.url"
                      v-text="s.name"
                    />

                    <v-responsive
                      v-if="i < studentsfooter.length - 1"
                      :key="`divider-${s.name}`"
                      class="mx-4 shrink hidden-sm-and-down"
                      max-height="24"
                    >
                      <v-divider vertical />
                    </v-responsive>
                  </template>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-footer>
    </v-container>
  </base-section>
</template>
<script>
  export default {
    data: () => ({
      isMobile: false,
      studentsfooter: [
        {
          name: 'Student Activities at ETS23',
          url: 'student-activities-23',
        },
        {
          name: 'Best Student Presentation Award',
          url: 'bspa',
        },
        {
          name: 'PhD Forum',
          url: 'student-phd-forum',
        },
        {
          name: 'McCluskey Award',
          url: 'mccluskey',
        },
        {
          name: 'Test Spring School',
          url: 'test-spring-school',
        },
        {
          name: 'Student Activities at ETS22',
          url: 'student-activities-22',
        },
      ],
      studentacts: [
        {
          title: 'Maria Michael',
          src: require('@/images/committees/mariamichael.jpeg'),
          text: 'University of Cyprus, CY',
        },
        {
          title: 'Maksim Jenihhin',
          src: require('@/images/committees/maksim.jpeg'),
          text: 'Taltech, EE',
        },
      ],
      activities: [
        {
          title: 'Test Spring School',
          to: 'test-spring-school',
          text: 'Ph.D. students interested in testing topics can attend the TSS (limited seats – first come, first serve). It will be held from 19 to 22 of May in Rifugio Donzella - Gorino Sullam (RO) - Italy',
        },
        {
          title: 'Best Student Presentation Award',
          to: 'bspa',
          text: 'Ph.D. Students presenting a regular paper at ETS\'23 concour to the best student presentation award. It is assigned depending on the presentation quality and audience feedback. The winner is announced at ETS\'24 opening. ',
        },
        {
          title: 'Ph.D. Forum',
          to: 'student-phd-forum',
          text: 'All Ph.D. students not concurring for McCluskey Award are suggested to participate. It consists of a short talk and a poster. The winner is announced at ETS\'23 closing and their paper will be included in the formal proceedings.',
        },
        {
          title: 'McCluskey Award',
          to: 'mccluskey',
          text: 'It is open for Ph.D. students that defended their thesis after April 2021 or will defend before December 2023. It consists of a short talk and a poster. The winner is announced at ETS\'23 closing and their paper will be included in the formal proceedings.',
        },
      ],
      mounted () {
        this.isMobile = (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
      },
    }),
  }
</script>
